import { callFunctionRaw } from "@/lib/callFunction";
import {
  derivePharmacyOnboardingTruth,
  readPharmacyProfile,
  savePharmacyOnboardingTruth,
  savePharmacyProfile,
} from "@/services/pharmacyLaneService.js";

async function invokeOrThrow(name, body = {}, options = {}) {
  const data = await callFunctionRaw(name, body, {
    timeoutMs: Number(options.timeoutMs || 15000),
    preferFreshSession: options.preferFreshSession === true,
    accessToken: String(options.accessToken || "").trim(),
  });
  if (data?.error) throw new Error(String(data.error));
  return data || {};
}

function runtimeOrigin() {
  if (typeof window === "undefined") return "http://localhost:4028";
  return String(window.location.origin || "http://localhost:4028").trim().replace(/\/+$/, "");
}

export async function getDoctorStripeConnectStatus() {
  return invokeOrThrow(
    "stripe-connect-status",
    {
      entity_type: "doctor",
      origin: runtimeOrigin(),
    },
    {
      timeoutMs: 8000,
      preferFreshSession: false,
    },
  );
}

export async function getPharmacyStripeConnectStatus() {
  const profile = readPharmacyProfile() || {};
  const data = await invokeOrThrow(
    "stripe-connect-status",
    {
      entity_type: "pharmacy",
      origin: runtimeOrigin(),
    },
    {
      timeoutMs: 8000,
      preferFreshSession: false,
    },
  );

  savePharmacyOnboardingTruth(profile, data);

  return data;
}

export async function startDoctorStripeConnect({
  refreshPath = "/settings/doctor/p/payout-preferences",
  returnPath = "/settings/doctor/p/payout-preferences?stripe=return",
  accessToken = "",
} = {}) {
  return invokeOrThrow("stripe-connect-onboarding", {
    entity_type: "doctor",
    origin: runtimeOrigin(),
    refresh_path: refreshPath,
    return_path: returnPath,
  }, {
    timeoutMs: 45000,
    preferFreshSession: !String(accessToken || "").trim(),
    accessToken,
  });
}

export async function startPharmacyStripeConnect({
  refreshPath = "/pharmacy/payments",
  returnPath = "/pharmacy/payments?stripe=return",
  testingSetup = false,
} = {}) {
  const profile = readPharmacyProfile() || {};
  const data = await invokeOrThrow("stripe-connect-onboarding", {
    entity_type: "pharmacy",
    origin: runtimeOrigin(),
    refresh_path: refreshPath,
    return_path: returnPath,
    testing_setup: testingSetup === true,
    pharmacy_profile: {
      pharmacy_name: profile?.pharmacyName || profile?.tradingName || "",
      trading_name: profile?.tradingName || "",
      country: profile?.country || "",
    },
  }, {
    timeoutMs: 45000,
    preferFreshSession: true,
  });

  if (String(data?.account_id || "").trim()) {
    savePharmacyOnboardingTruth(profile, {
      ...data,
      connected: true,
    });
  } else {
    const truth = derivePharmacyOnboardingTruth(profile, data);
    savePharmacyProfile({
      ...profile,
      onboardingState: truth.onboardingState,
      paymentState: truth.paymentState,
    });
  }

  return data;
}

export default {
  getDoctorStripeConnectStatus,
  startDoctorStripeConnect,
  getPharmacyStripeConnectStatus,
  startPharmacyStripeConnect,
};
